/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuremovedescription2Inputs */

const en_menuremovedescription2 = /** @type {(inputs: Menuremovedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests will no longer see it in the app or on the web. This cannot be undone.`)
};

const de_menuremovedescription2 = /** @type {(inputs: Menuremovedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gäste sehen davon dann nichts mehr in der App und im Web. Das lässt sich nicht rückgängig machen.`)
};

/**
* | output |
* | --- |
* | "Guests will no longer see it in the app or on the web. This cannot be undone." |
*
* @param {Menuremovedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuremovedescription2 = /** @type {((inputs?: Menuremovedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuremovedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuremovedescription2(inputs)
	return de_menuremovedescription2(inputs)
});
export { menuremovedescription2 as "menuRemoveDescription" }